// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 889 ? "route-permission" : chunkId) + "." + {"739":"24d5c143","787":"bc64e2a5","889":"056c83ef"}[chunkId] + ".chunk.js";
};